import { Game } from '@Game/Game';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { ETurboModeLevels } from '@GFTypes/GameStoreTypes';

export class TurboManager {
    private readonly game: Game;
    private readonly gameStore: GameStore;

    constructor(game: Game) {
        this.game = game;
        this.gameStore = this.game.gameStore;
        game.gameStore.on(EGameStoreKeys.TurboModeState, this.onTurboStateChange, this);
    }

    public onTurboStateChange(): void {
        const { baseGameLevel, specialGameLevel, animationsSpeedPerLevel } = this.game.gameStore.get(EGameStoreKeys.TurboModeState);
        const currentLevel = specialGameLevel ?? baseGameLevel;
        this.game.spines.forEach((spineWrapper) => {
            if (spineWrapper.turboAffectsAnimationSpeed) spineWrapper.setSpeed(animationsSpeedPerLevel[currentLevel]);
        });
    }
}

export function getCurrentTurboLevel(gameStore: GameStore): ETurboModeLevels {
    const { baseGameLevel, specialGameLevel } = gameStore.get(EGameStoreKeys.TurboModeState);
    return specialGameLevel ?? baseGameLevel;
}
